export default function SubmissionComplete({ message }: { message?: string }) {
  return (
    <div className="col-span-full mt-8 flex h-[415px] items-center justify-center bg-black py-10 px-4 text-white lg:col-span-6 lg:col-start-4 lg:h-[352px] lg:p-10">
      <h5 className="text-center">{message || "Thank you for subscribing!"}</h5>
    </div>
  );
}
